import { Editor, Transforms } from 'slate';
import { nanoid } from 'nanoid';
import { EDITABLE_BLANK_VOID } from '../types';

export const addBlank = (editor: Editor) => {
  Transforms.insertNodes(editor, getEmptyBlankNode());
  Transforms.move(editor, { distance: 1, unit: 'word' });
};

export const getEmptyBlankNode = () => {
  return {
    type: EDITABLE_BLANK_VOID,
    children: [
      {
        blankId: nanoid(),
        text: '',
      },
    ],
  };
};
